import { BLOCKS, } from "@contentful/rich-text-types";
import { MARK_TYPES, INLINE_TYPES, BLOCK_TYPES } from "./constants";
export const isNotNull = (value) => value !== null;
export const getAsList = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    return [value];
};
export const isBlockType = (nodeType) => BLOCK_TYPES.includes(nodeType);
export const isInlineType = (nodeType) => INLINE_TYPES.includes(nodeType);
export const isMarkType = (nodeType) => MARK_TYPES.includes(nodeType);
export const isNodeTypeMark = (node) => {
    return isMarkType(node.type);
};
export const isNodeTypeText = (node) => {
    if (isNodeTypeMark(node)) {
        return false;
    }
    if (node.nodeType === "text") {
        return true;
    }
    return false;
};
export const createDocumentNode = (content, data = {}) => ({
    nodeType: BLOCKS.DOCUMENT,
    data,
    content,
});
//# sourceMappingURL=utils.js.map